import { createFileRoute, redirect } from "@tanstack/react-router";

// Back in Engineering (ADR-048, reverting the move of ADR-046): links from
// that time keep working.
export const Route = createFileRoute("/_app/master-data/engineering-boms")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/engineering/engineering-boms", search: search as never, replace: true });
  },
});
